module.exports = __webpack_public_path__ + "img/xxdt.234d1dcc.png";